import React from 'react';

import './avatar.scss';

export default function Avatar(props) {
  return (
    <div className={`avatar ${props.show ? 'show' : 'hide'}`}>
      {props.children}
    </div>
  );
}
